import { useState } from 'react';
import { Button, ConfirmationModalContent, ModalPopup } from 'components';

import style from '../noteEdit.module.scss';

type CancelButtonProps = {
  children: string;
  onClick?: () => void;
  className?: string;
  confirmTitle?: string;
  confirmText?: string;
  confirmButtonText?: string;
  rejectButtonText?: string;
};

export const CancelButton = ({
  children,
  onClick,
  className,
  confirmTitle = 'Are you sure you want to discard your changes?',
  confirmText = ' ',
  confirmButtonText = 'Yes, discard',
  rejectButtonText = 'No, return to editing'
}: CancelButtonProps) => {
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);

  const handleConfirm = () => {
    setShowConfirmationModal(false);
    onClick?.();
  };

  return (
    <>
      <Button
        customStyleClass={className}
        theme="transparent"
        type="button"
        text={children}
        handleOnClick={() => setShowConfirmationModal(true)}
      />
      <ModalPopup open={showConfirmationModal} handleClose={() => setShowConfirmationModal(false)}>
        <ConfirmationModalContent
          confirmButtonText={confirmButtonText}
          rejectButtonText={rejectButtonText}
          title={confirmTitle}
          customClassInsideContainer={style.deleteNoteModal}
          text={confirmText}
          handleConfirm={handleConfirm}
          handleReject={() => setShowConfirmationModal(false)}
        />
      </ModalPopup>
    </>
  );
};
